import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "px-9 pt-7 d-flex flex-column card-rounded h-375px h-xl-275px pb-5 w-100 bg-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-white fw-bold fs-3" }, "Profit margin by client")
], -1)
const _hoisted_5 = {
  class: "bg-body shadow-sm card-rounded px-6 py-9",
  style: {"margin-top":"10px"}
}
const _hoisted_6 = {
  class: "d-flex flex-column",
  style: {"grid-gap":"16px"}
}
const _hoisted_7 = { class: "symbol symbol-45px me-5" }
const _hoisted_8 = { class: "symbol-label bg-lighten" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_11 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_12 = {
  key: 1,
  class: "cursor-pointer fs-5 text-gray-800 text-hover-primary fw-bold"
}
const _hoisted_13 = { class: "text-gray-500 fw-semibold fs-7" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")!
  const _component_ArrowDownIcon = _resolveComponent("ArrowDownIcon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!Object.keys(_ctx.statisticData).length)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  description: "No data for selected period",
                  "image-size": "45"
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-items-center",
                key: index
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    (item.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.logo,
                          class: "w-100 h-100",
                          alt: "Company logo"
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (item.client != 'Others')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/client/${item.company_id}`,
                          class: "cursor-pointer fs-5 text-gray-800 text-hover-primary fw-bold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.client), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.client), 1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.current) + " % ", 1)
                  ]),
                  (item.trend)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (item.trend == 'up')
                          ? (_openBlock(), _createBlock(_component_ArrowUpIcon, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_ArrowDownIcon, { key: 1 }))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ])
    ])
  ]))
}